import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { FeaturedProductLines } from '../components/FeaturedProductLines';
import { ProductGrid } from '../components/ProductGrid';
import { AboutSection } from '../components/AboutSection';
import { UsedSalesSection } from '../components/UsedSalesSection';
import { FinancingSection } from '../components/FinancingSection';
import { AssociationsSection } from '../components/AssociationsSection';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen w-full bg-white" data-id="element-377">
      <Header data-id="element-378" />
      <main data-id="element-379">
        <Hero data-id="element-380" />
        <FeaturedProductLines data-id="element-381" />
        <ProductGrid data-id="element-382" />
        <AboutSection data-id="element-383" />
        <UsedSalesSection data-id="element-384" />
        <FinancingSection data-id="element-385" />
        <AssociationsSection data-id="element-386" />
        <ContactSection data-id="element-387" />
      </main>
      <Footer data-id="element-388" />
    </div>;
}